/* Dress To menu (dtm): panels, hover intent and accordions for snippets/header-drawer.liquid.
   The theme's <header-drawer> still opens/closes the drawer, traps focus and locks scrolling. */
(function () {
  'use strict';
  var DESK = window.matchMedia('(min-width: 900px) and (hover: hover)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(drawer) {
    if (!drawer || drawer.dataset.dtmReady) return;
    drawer.dataset.dtmReady = '1';
    var details = drawer.closest('details');
    var nav = drawer.querySelector('.dtm__nav');
    var mark = drawer.querySelector('.dtm__mark');
    var tops = Array.prototype.slice.call(drawer.querySelectorAll('[data-dtm-sub]'));
    var accs = Array.prototype.slice.call(drawer.querySelectorAll('.dtm__acc'));
    var open = -1, hoverT = null, lastX = 0, dx = 0;

    function panel(i) { return drawer.querySelector('#DtmPanel-' + i); }

    function openSub(i) {
      if (open === i) return;
      var p = panel(i); if (!p) return;
      drawer.querySelectorAll('.dtm__panel.is-open').forEach(function (x) { x.classList.remove('is-open'); });
      tops.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); t.parentElement.classList.remove('is-active'); });
      var t = tops.filter(function (x) { return Number(x.dataset.dtmSub) === i; })[0];
      p.classList.add('is-open'); open = i;
      drawer.dataset.cols = p.dataset.cols || '1';
      drawer.classList.add('is-wide');
      if (t) {
        t.setAttribute('aria-expanded', 'true'); t.parentElement.classList.add('is-active');
        if (mark && nav) {
          var tr = t.getBoundingClientRect(), nr = nav.getBoundingClientRect();
          mark.style.setProperty('--y', (tr.top - nr.top) + 'px'); mark.style.setProperty('--h', tr.height + 'px');
          mark.classList.add('is-on');
        }
      }
      if (!DESK.matches) setTimeout(function () { var b = p.querySelector('[data-dtm-back]'); if (b) b.focus({ preventScroll: true }); }, 60);
    }

    function closeSub() {
      drawer.querySelectorAll('.dtm__panel.is-open').forEach(function (x) {
        x.classList.remove('is-open');
        if (!DESK.matches) x.querySelectorAll('.dtm__acc[open]').forEach(function (d) { d.open = false; });
      });
      tops.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); t.parentElement.classList.remove('is-active'); });
      drawer.classList.remove('is-wide');
      if (mark) mark.classList.remove('is-on');
      open = -1;
    }

    /* desktop: switch only after the pointer rests on a section (longer while it travels right toward the open panel);
       mousemove, not mouseenter, so the drawer sliding in under a still cursor opens nothing by itself */
    if (nav) nav.addEventListener('mousemove', function (e) { dx = e.clientX - lastX; lastX = e.clientX; });
    tops.forEach(function (t) {
      var i = Number(t.dataset.dtmSub), pending = false;
      t.addEventListener('click', function (e) {
        if (!DESK.matches || t.getAttribute('href') === '#' || !t.getAttribute('href')) { e.preventDefault(); openSub(i); }
      });
      t.addEventListener('mousemove', function () {
        if (!DESK.matches || open === i || pending) return;
        clearTimeout(hoverT); pending = true;
        hoverT = setTimeout(function () { pending = false; openSub(i); }, open < 0 ? 40 : dx > 1 ? 170 : 70);
      });
      t.addEventListener('mouseleave', function () { clearTimeout(hoverT); pending = false; });
      t.addEventListener('focus', function () { if (DESK.matches) openSub(i); });
    });
    drawer.querySelectorAll('[data-dtm-back]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = open; closeSub();
        var t = tops.filter(function (x) { return Number(x.dataset.dtmSub) === i; })[0];
        if (t) t.focus({ preventScroll: true });
      });
    });

    /* groups: all open on desktop; on phones closed, opening with a height animation, one at a time */
    function mode() {
      accs.forEach(function (d) { d.open = DESK.matches; var s = d.querySelector('summary'); if (s) s.tabIndex = DESK.matches ? -1 : 0; });
    }
    function slide(d, toOpen) {
      var body = d.querySelector('summary + *');
      if (d._anim) { d._anim.cancel(); d._anim = null; }
      if (!body || REDUCE.matches || !body.animate) { d.open = toOpen; d.classList.remove('is-closing'); return; }
      if (toOpen) d.open = true;
      var h = body.scrollHeight;
      d.classList.toggle('is-closing', !toOpen);
      body.style.overflow = 'hidden';
      d._anim = body.animate(toOpen ? [{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }] : [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
        { duration: toOpen ? 340 : 260, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
      d._anim.onfinish = function () { body.style.overflow = ''; d._anim = null; d.classList.remove('is-closing'); if (!toOpen) d.open = false; };
    }
    accs.forEach(function (d) {
      var s = d.querySelector('summary'); if (!s) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (DESK.matches) return;
        var opening = !d.open || d.classList.contains('is-closing');
        if (opening) d.closest('.dtm__panel').querySelectorAll('.dtm__acc[open]').forEach(function (o) { if (o !== d) slide(o, false); });
        slide(d, opening);
      });
    });
    mode();
    var onMode = function () { closeSub(); mode(); };
    if (DESK.addEventListener) DESK.addEventListener('change', onMode); else if (DESK.addListener) DESK.addListener(onMode);

    /* the drawer closed (theme logic): go back to the list. The theme's close also shuts every <details> inside the
       drawer, including the groups, so put them back the way this screen size shows them (all open on desktop) */
    if (details) details.addEventListener('toggle', function () { if (!details.open) closeSub(); mode(); });
  }

  function boot() { document.querySelectorAll('[data-dtm]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
